import FootballStatsCategory from "../../stats/football-stats-category";
import FootballState from "../../state/football-state";
import StatsRule from "../../../common/stats-rule";

export default class SpikeStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Spike &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { spikeTeamAttOnly } = gameContext.gameConfig.general || {};

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.spikedBy.teamId,
            playerId: spikeTeamAttOnly ? null : fragment.spikedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.SPIKE,
            values: {
                attempted: 1
            }
        });
    }
}
